/* eslint-disable jira/filename-case */
import { RateLimiter } from './RateLimiter.tsx';

// each location can only send four requests per minute for each level + location + first 15 chars of message
// This is a upper-bound, not a target so please send less.
const rateLimiter = new RateLimiter(60, 4);

export function getLoggerRateLimiter(): RateLimiter {
	return rateLimiter;
}
